import {useState} from "react";
import {Row} from "react-bootstrap";
import common from "../../../translations/it/common.json";
import Input from "../../../components/inputText/Input";
import Calendar from "../../../components/calendar/Calendar";
import Button from "../../../components/Button/Button";
import styleElencoSportelli from "../../sportelli/ElencoSportelli.module.css";
import {useDispatch, useSelector} from "react-redux";
import AnagraficaService from "../../../services/AnagraficaService";
import Spinner from "../../../components/spinner/Spinner";
import Utils from "../../../utils/Utils";
import {useHistory} from "react-router";
import {setFlagInserimentoManuale, setStateAssistente} from "../../../actions/IndexActions";
import Enums from "../../../utils/Enums.json";


function RicercaAssistentiAF(props) {

    const [state, setState] = useState({cognome: "", nome: "", dataNascita: "", codiceFiscale: ""})
    const [showSpinner, setShowSpinner] = useState(false)
    const [flagCercaAssistente, setFlagCercaAssistente] = useState(false)
    const button = useSelector(state => state.searchReducer)
    const [rerenderCalendar,setRerenderCalendar] = useState(0)
    const [elenco, setElenco] = useState(null)
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
    const comuniPerDescrizione = JSON.parse(sessionStorage.getItem("comuniPerDescrizione"))
    const nazioniPerCodice = JSON.parse(sessionStorage.getItem("nazioniPerCodice"))
    const nazioniPerDescrizione = JSON.parse(sessionStorage.getItem("nazioniPerDescrizione"))
    const provincePerCodice = JSON.parse(sessionStorage.getItem("provincePerCodice"))
    const siglaProvincePerCodice = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const [flagDisabilitaCerca,setFlagDisabilitaCerca] = useState(true)
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}

    const dispatch = useDispatch()
    const history = useHistory()

    function getAnagraficheAndCandidati() {
        setShowSpinner(true)
        let params = {}
        if (state.codiceFiscale) {
            params.codiceFiscale = state.codiceFiscale
        } else {
            params.nome = state.nome
            params.cognome = state.cognome
            if (state.dataNascita) {
                params.dataNascita = state.dataNascita
                params.dataNascita = Utils.transformDateForBackend(params.dataNascita)
            }
        }
        if (!button || !button.buttonFlag) {
            params.ricerca = false
        } else {
            params.ricerca = true
        }
        AnagraficaService.getAnagraficheAndCandidati(params).then(res => {
            let anagraficheAndCandidati = res.data
            if (anagraficheAndCandidati.candidati && anagraficheAndCandidati.candidati.length > 0) {
                anagraficheAndCandidati.candidati.forEach(candidato => {
                    candidato.nome = candidato.nome.toUpperCase()
                    candidato.cognome = candidato.cognome.toUpperCase()
                    candidato.codiceFiscale = candidato.codiceFiscale.toUpperCase()
                    candidato.comuneNascita = comuniPerCodice[candidato.comuneNascita] ? comuniPerCodice[candidato.comuneNascita].descrizione : nazioniPerCodice[candidato.comuneNascita]?nazioniPerCodice[candidato.comuneNascita].descrizione:""
                    candidato.dataNascita = Utils.transformDateForFrontend(candidato.dataNascita)
                    candidato.flagCandidato = true
                })
            }
            if (anagraficheAndCandidati.anagrafiche && anagraficheAndCandidati.anagrafiche.length > 0) {
                anagraficheAndCandidati.anagrafiche.forEach(anagrafica => {
                    anagrafica.nome = anagrafica.nome.toUpperCase()
                    anagrafica.cognome = anagrafica.cognome.toUpperCase()
                    anagrafica.codiceFiscale = anagrafica.codiceFiscale.toUpperCase()
                    anagrafica.comuneNascita = comuniPerCodice[anagrafica.comuneNascita] ? comuniPerCodice[anagrafica.comuneNascita].descrizione : nazioniPerCodice[anagrafica.comuneNascita]?nazioniPerCodice[anagrafica.comuneNascita].descrizione:""
                    anagrafica.dataNascita = Utils.transformDateForFrontend(anagrafica.dataNascita)
                    anagrafica.flagCandidato = false
                })
            }
            let newRows = anagraficheAndCandidati.candidati && anagraficheAndCandidati.candidati.length > 0 && anagraficheAndCandidati.anagrafiche && anagraficheAndCandidati.anagrafiche.length > 0 ?
                anagraficheAndCandidati.candidati.concat(anagraficheAndCandidati.anagrafiche) :
                anagraficheAndCandidati.candidati && anagraficheAndCandidati.candidati.length > 0 ? anagraficheAndCandidati.candidati :
                    anagraficheAndCandidati.anagrafiche && anagraficheAndCandidati.anagrafiche.length > 0 ? anagraficheAndCandidati.anagrafiche : []
            createElencoCandidatiAnagrafiche(newRows)
            setFlagCercaAssistente(true)
            setShowSpinner(false)
            let issues = res.data.issueDTOS??null
            let elencoIssues = '<ul>'
            if(issues){
                issues.forEach(issue => {
                    let i = '<li>'+issue.message+'</li>'
                    elencoIssues = elencoIssues.concat(i)
                })
            }
            let elencoIssuePerToaster = elencoIssues+'</ul>'
            if(issues != null)window.alert(Enums.TOASTERTYPE.INFORMATION.descrizione,elencoIssuePerToaster);
        }).catch(reason => {
            console.log("Errore Operation GET Candidati and Anagrafiche: " + reason)
            createElencoCandidatiAnagrafiche([])
            setShowSpinner(false)
        })
    }

    function createElencoCandidatiAnagrafiche(rows) {
        let rowsElenco = []
        if (rows.length > 0) {
            rows.forEach(element => {
                let row = (
                    <div className={"row"} style={{borderBottom: "1px solid grey", alignItems: "center"}}>
                        <div className={"col-2"}>
                            <span>{element.cognome}</span>
                        </div>
                        <div className={"col-2"}>
                            <span>{element.nome}</span>
                        </div>
                        <div className={"col-2"}>
                            <span>{element.dataNascita}</span>
                        </div>
                        <div className={"col-2"}>
                            <span>{element.comuneNascita}</span>
                        </div>
                        <div className={"col-2"}>
                            <span>{element.codiceFiscale}</span>
                        </div>
                        <div className={"col-2"} style={{display:sessioneUtente?.ruolo?.toUpperCase() !== "RAF-RDS"?"none":""}}>
                            <Button
                                className={styleElencoSportelli.buttonTable}
                                onClick={() => onClickButtonModifica(element)}
                                text={element.flagCandidato ? "Modifica Profilo" : "Nuovo Record"}
                                id={"button" + element.id}
                                style={{width: "auto"}}
                                typeButton={"White"}
                            />
                        </div>
                    </div>
                )
                rowsElenco.push(row)
            })
        }
        let newElenco = (
            <div>
                <div className={"row"} style={{borderBottom: "1px solid grey", alignItems: "center"}}>
                    <div className={"col-2"}>
                        <span style={{fontWeight: "bold", color: "grey"}}>Cognome</span>
                    </div>
                    <div className={"col-2"}>
                        <span style={{fontWeight: "bold", color: "grey"}}>Nome</span>
                    </div>
                    <div className={"col-2"}>
                        <span style={{fontWeight: "bold", color: "grey"}}>Data di Nascita</span>
                    </div>
                    <div className={"col-2"}>
                        <span style={{fontWeight: "bold", color: "grey"}}>Comune di Nascita</span>
                    </div>
                    <div className={"col-2"}>
                        <span style={{fontWeight: "bold", color: "grey"}}>Codice Fiscale</span>
                    </div>
                </div>
                {rowsElenco.length > 0 ? rowsElenco : <div style={{marginTop: "2rem", textAlign: "center"}}><span
                    style={{fontWeight: "bold", fontSize: "20px"}}>La ricerca non ha prodotto risultati</span></div>}
            </div>

        )
        setElenco(newElenco)

    }

    function onClickButtonModifica(element) {

        if(element.flagCandidato){
            Utils.recuperaDatiAssistente(element.id,dispatch,history,"/wizardRegistro",comuniPerCodice,siglaProvincePerCodice,nazioniPerCodice, provincePerCodice)
        }else{
            element.provinciaNascita = provincePerCodice[comuniPerDescrizione[element.comuneNascita].codiceProvincia]
            element.comuneNascita = comuniPerDescrizione[element.comuneNascita]?comuniPerDescrizione[element.comuneNascita].codice:nazioniPerDescrizione[element.comuneNascita]?nazioniPerDescrizione[element.comuneNascita].codice:""
            let datiAnagraficiAssistente = Utils.createObjectDatiAnagraficiAssistente(element,comuniPerCodice,siglaProvincePerCodice,nazioniPerCodice, true)
            dispatch(setStateAssistente("datiAnagrafici", datiAnagraficiAssistente ? datiAnagraficiAssistente : {}))
            history.push({
                pathname: "/wizardRegistro"
            })
        }

    }

    function onChange(id, value) {
        let newState = {...state}
        newState[id] = value
        if (id === "codiceFiscale") {
            newState.nome = ""
            newState.cognome = ""
            newState.dataNascita = ""
        } else {
            newState.codiceFiscale = ""
        }
        setRerenderCalendar(rerenderCalendar +1)
        setState(newState)
        disabilitaCerca(newState)
    }

    function onClickInserisciManualmente(){
        dispatch(setFlagInserimentoManuale(true))
        history.push({
            pathname: "/wizardRegistro",
            datiAnagrafici:{cognome:state.cognome, nome:state.nome, dataNascita:state.dataNascita, codiceFiscale:state.codiceFiscale}
        })
    }

    function disabilitaCerca(newState){
        if((!newState.codiceFiscale && (!newState.nome || !newState.cognome)) || (newState.codiceFiscale && !Utils.isCFValid(newState.codiceFiscale))){
            setFlagDisabilitaCerca(true)
        }else{
            setFlagDisabilitaCerca(false)
        }
    }

    return (<div className={" pl-4 "} style={{marginTop: "50px"}}>
        <Spinner show={showSpinner}/>
        <div className={"row"}>
            <div className="col-10">
                <p style={{
                    fontWeight: "bold",
                    fontSize: "20px"
                }}>{button && button.buttonFlag ? "Ricerca Assistente" : common.RicercaAssistente.titolo}</p>
            </div>
            <div className="col-2">
                <p style={{fontWeight: "bold", fontSize: "16px", color:"red"}}>Campo obbligatorio*</p>
            </div>
        </div>
        <Row>
            <div className={"col-2"}>
                <span style={{fontWeight: "bold", fontSize: "16px"}}>Cognome<span style={{fontWeight: "bold", fontSize: "14px", color:"red"}}>*</span></span>
                <Input ariaLabel={"Cognome (obbligatorio)"} placeholder={"Inserisci cognome assistito"} id={"cognome"} value={state.cognome}
                       onChange={(event) => onChange(event.target.id, event.target.value)}/>
            </div>
            <div className={"col-2"}>
                <span style={{fontWeight: "bold", fontSize: "16px"}}>Nome<span style={{fontWeight: "bold", fontSize: "14px", color:"red"}}>*</span></span>
                <Input ariaLabel={"Nome (obbligatorio)"} placeholder={"Inserisci nome assistito"} id={"nome"} value={state.nome}
                       onChange={(event) => onChange(event.target.id, event.target.value)}/>
            </div>
            <div className={"col-3"}>
                <span style={{fontWeight: "bold", fontSize: "16px"}}>Data di nascita</span>
                <Calendar id={"dataNascita"} ariaLabel={"Data di nascita"} value={state.dataNascita} onChange={onChange} rerender={rerenderCalendar}/>
            </div>
            <div className={"col-1"} style={{display: "flex", justifyContent: "center", marginTop: "36px"}}>
                <span style={{opacity: "0.5"}}>Oppure</span>
            </div>
            <div className={"col-3"}>
                <span style={{fontWeight: "bold", fontSize: "16px"}}>Codice fiscale<span style={{fontWeight: "bold", fontSize: "14px", color:"red"}}>*</span></span>
                <Input ariaLabel={"Codice fiscale (obbligatorio)"} placeholder={"Inserisci codice fiscale assistito"} id={"codiceFiscale"}
                       errorClause={state.codiceFiscale && !Utils.isCFValid(state.codiceFiscale)}
                       errorMessage={"Codice fiscale non valido"}
                       value={state.codiceFiscale}
                       onChange={(event) => onChange(event.target.id, event.target.value)}/>
            </div>
            <div className={"col-1"}>
                <Button
                    id={"CercaAssistente"}
                    onClick={getAnagraficheAndCandidati}
                    typeButton={"Blue"}
                    text={"Cerca"}
                    style={{height: "45px", width: "100px", marginTop: "27px"}}
                    disabled={flagDisabilitaCerca}
                />
            </div>
        </Row>

        {flagCercaAssistente &&
        <div>
            <div className={" pt-2 "}>
                <hr style={{border: "0.5px solid grey"}}/>
            </div>
            <p style={{fontWeight: "bold", color: "grey", fontSize: "25px"}}>Risultati</p>
            {elenco}
            {props.flagRicercaOInserisci === "INSERISCI" ?
                <div>
                    <p style={{fontSize: "15px", marginTop: "40px", textAlign: "center"}}>La ricerca non ha prodotto
                        risultati di interesse?</p>
                    {/* Era un <p onClick>: non focusabile ne' attivabile da tastiera
                        (WCAG 2.1.1). Convertito in <button type="button"> con reset di
                        stile e width:100% per conservare il centraggio del testo, quindi
                        la resa grafica e' invariata. */}
                    <button type="button" style={{
                        fontSize: "15px",
                        marginTop: "-15px",
                        textAlign: "center",
                        cursor: "pointer",
                        color: "rgb(27, 126, 169)",
                        background: "none",
                        border: "none",
                        padding: 0,
                        width: "100%",
                        display: "block",
                        fontFamily: "inherit"
                    }} onClick={onClickInserisciManualmente}>Inserisci i dati dell'assistente manualmente</button>
                </div> : <></>}
        </div>}
    </div>);

}

export default RicercaAssistentiAF;
